import { getEnvironment } from '@/helpers/utils';
import { toArray } from '@/helpers/utils';
import analyze from 'rgbaster';
var DeltaE = require('delta-e');
import ColorThief from './../../../node_modules/colorthief/dist/color-thief.mjs';

export const Colorschemes = {
    state: {
        colorschemes: {
            1: {
                id: 1,
                pos: 1,
                group: 1,
                colors: [
                    '#f20519',
                    '#ff575c',
                    '#ffc7c7',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            2: {
                id: 2,
                pos: 2,
                group: 1,
                colors: [
                    '#bf0626',
                    '#f20519',
                    '#ffd3c9',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            3: {
                id: 3,
                pos: 3,
                group: 1,
                colors: [
                    '#b40029',
                    '#dc3545',
                    '#ffbca8',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            4: {
                id: 4,
                pos: 4,
                group: 1,
                colors: [
                    '#f2133c',
                    '#b82c3a',
                    '#bbe0ea',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            5: {
                id: 5,
                pos: 5,
                group: 1,
                colors: [
                    '#f9464c',
                    '#cc3c48',
                    '#fddad0',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            6: {
                id: 6,
                pos: 6,
                group: 1,
                colors: [
                    '#f2391c',
                    '#b20012',
                    '#ffd9c4',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            7: {
                id: 7,
                pos: 7,
                group: 1,
                colors: [
                    '#cc1717',
                    '#dd4a44',
                    '#5d1e32',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            8: {
                id: 8,
                pos: 8,
                group: 1,
                colors: [
                    '#cb3140',
                    '#e2545b',
                    '#1e2846',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            20: {
                id: 20,
                pos: 9,
                group: 2,
                colors: [
                    '#f36f21',
                    '#f29f28',
                    '#86000e',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            21: {
                id: 21,
                pos: 10,
                group: 2,
                colors: [
                    '#fb9353',
                    '#f2bc8d',
                    '#433f59',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            22: {
                id: 22,
                pos: 11,
                group: 2,
                colors: [
                    '#fa8b38',
                    '#d47c4d',
                    '#ffe6c9',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            23: {
                id: 23,
                pos: 12,
                group: 2,
                colors: [
                    '#d36422',
                    '#fa8b38',
                    '#1a3352',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            24: {
                id: 24,
                pos: 13,
                group: 2,
                colors: [
                    '#fa6320',
                    '#fb8024',
                    '#8d080f',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            25: {
                id: 25,
                pos: 14,
                group: 2,
                colors: [
                    '#d75645',
                    '#f36f21',
                    '#2e4069',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            26: {
                id: 26,
                pos: 15,
                group: 2,
                colors: [
                    '#fb9c5b',
                    '#fbce8a',
                    '#a23814',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            27: {
                id: 27,
                pos: 16,
                group: 2,
                colors: [
                    '#fa6320',
                    '#b34617',
                    '#ffe6be',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            40: {
                id: 40,
                pos: 17,
                group: 3,
                colors: [
                    '#fee64e',
                    '#fff786',
                    '#576f72',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            41: {
                id: 41,
                pos: 18,
                group: 3,
                colors: [
                    '#f8e05e',
                    '#e8d156',
                    '#477093',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            42: {
                id: 42,
                pos: 19,
                group: 3,
                colors: [
                    '#ffdf74',
                    '#edc540',
                    '#3e5d62',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            43: {
                id: 43,
                pos: 20,
                group: 3,
                colors: [
                    '#ffe240',
                    '#f2b84b',
                    '#686d8c',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            44: {
                id: 44,
                pos: 21,
                group: 3,
                colors: [
                    '#f3cb2f',
                    '#f2d857',
                    '#ad654a',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            45: {
                id: 45,
                pos: 22,
                group: 3,
                colors: [
                    '#fbc52e',
                    '#fcdc72',
                    '#786883',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            46: {
                id: 46,
                pos: 23,
                group: 3,
                colors: [
                    '#f2d74f',
                    '#f2e088',
                    '#9d7382',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            47: {
                id: 47,
                pos: 24,
                group: 3,
                colors: [
                    '#eddd77',
                    '#fdf1a1',
                    '#5f6386',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            60: {
                id: 60,
                pos: 25,
                group: 4,
                colors: [
                    '#e5eb33',
                    '#acbe51',
                    '#5b6e2f',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            61: {
                id: 61,
                pos: 26,
                group: 4,
                colors: [
                    '#b4d97e',
                    '#d2f2a2',
                    '#3d6899',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            62: {
                id: 62,
                pos: 27,
                group: 4,
                colors: [
                    '#c1f257',
                    '#9cd861',
                    '#805858',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            63: {
                id: 63,
                pos: 28,
                group: 4,
                colors: [
                    '#c3d973',
                    '#9cbf50',
                    '#4e644d',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            64: {
                id: 64,
                pos: 29,
                group: 4,
                colors: [
                    '#b7ca79',
                    '#7da558',
                    '#316c2e',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            65: {
                id: 65,
                pos: 30,
                group: 4,
                colors: [
                    '#71d5b6',
                    '#7ef2ce',
                    '#333f55',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            66: {
                id: 66,
                pos: 31,
                group: 4,
                colors: [
                    '#78d390',
                    '#80ed9c',
                    '#6c6074',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            67: {
                id: 67,
                pos: 32,
                group: 4,
                colors: [
                    '#5fea4c',
                    '#9bf88f',
                    '#3d5d71',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            80: {
                id: 80,
                pos: 33,
                group: 5,
                colors: [
                    '#375d3b',
                    '#558f5b',
                    '#92fad2',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            81: {
                id: 81,
                pos: 34,
                group: 5,
                colors: [
                    '#2e5a12',
                    '#72a622',
                    '#c5faad',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            82: {
                id: 82,
                pos: 35,
                group: 5,
                colors: [
                    '#3a9974',
                    '#67e3b3',
                    '#254a41',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            83: {
                id: 83,
                pos: 36,
                group: 5,
                colors: [
                    '#165764',
                    '#588680',
                    '#96eddc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            84: {
                id: 84,
                pos: 37,
                group: 5,
                colors: [
                    '#25642b',
                    '#4a864f',
                    '#acc6a4',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            85: {
                id: 85,
                pos: 38,
                group: 5,
                colors: [
                    '#4e7364',
                    '#7ca697',
                    '#baffdd',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            86: {
                id: 86,
                pos: 39,
                group: 5,
                colors: [
                    '#1c473d',
                    '#63baa7',
                    '#c6fffb',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            87: {
                id: 87,
                pos: 40,
                group: 5,
                colors: [
                    '#287422',
                    '#46993c',
                    '#e0dcdc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            100: {
                id: 100,
                pos: 41,
                group: 6,
                colors: [
                    '#bbe5f3',
                    '#87c9e5',
                    '#057691',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            101: {
                id: 101,
                pos: 42,
                group: 6,
                colors: [
                    '#85e6f2',
                    '#5cb8cc',
                    '#057691',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            102: {
                id: 102,
                pos: 43,
                group: 6,
                colors: [
                    '#a0e3f2',
                    '#4bd4f2',
                    '#1e4a6a',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            103: {
                id: 103,
                pos: 44,
                group: 6,
                colors: [
                    '#abc8e2',
                    '#c4d7ed',
                    '#3760a0',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            104: {
                id: 104,
                pos: 45,
                group: 6,
                colors: [
                    '#acd7f2',
                    '#63b0f2',
                    '#3760a0',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            105: {
                id: 105,
                pos: 46,
                group: 6,
                colors: [
                    '#b3e0f2',
                    '#89c2d9',
                    '#754d7c',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            106: {
                id: 106,
                pos: 47,
                group: 6,
                colors: [
                    '#bbe5f3',
                    '#8bc3db',
                    '#6982a5',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            107: {
                id: 107,
                pos: 48,
                group: 6,
                colors: [
                    '#c3ebfe',
                    '#9fc7e8',
                    '#3760a0',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            120: {
                id: 120,
                pos: 49,
                group: 7,
                colors: [
                    '#0d3e6e',
                    '#1362ae',
                    '#9ad4e5',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            121: {
                id: 121,
                pos: 50,
                group: 7,
                colors: [
                    '#1678d4',
                    '#1362ae',
                    '#b6e7f0',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            122: {
                id: 122,
                pos: 51,
                group: 7,
                colors: [
                    '#0d507e',
                    '#1b73c1',
                    '#f7a229',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            123: {
                id: 123,
                pos: 52,
                group: 7,
                colors: [
                    '#304269',
                    '#5988a1',
                    '#7fccd3',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            124: {
                id: 124,
                pos: 53,
                group: 7,
                colors: [
                    '#1767a6',
                    '#339df5',
                    '#ffc684',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            125: {
                id: 125,
                pos: 54,
                group: 7,
                colors: [
                    '#4685da',
                    '#a0c2f2',
                    '#e5f8ff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            126: {
                id: 126,
                pos: 55,
                group: 7,
                colors: [
                    '#125694',
                    '#1776cb',
                    '#eb9826',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            127: {
                id: 127,
                pos: 56,
                group: 7,
                colors: [
                    '#304269',
                    '#5988a1',
                    '#9aded6',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            140: {
                id: 140,
                pos: 57,
                group: 8,
                colors: [
                    '#e8c0dd',
                    '#fbe0fe',
                    '#9d5da6',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            141: {
                id: 141,
                pos: 58,
                group: 8,
                colors: [
                    '#f7cdfc',
                    '#e0c6fd',
                    '#bb7ffb',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            142: {
                id: 142,
                pos: 59,
                group: 8,
                colors: [
                    '#e9c9f2',
                    '#c193de',
                    '#8d54b7',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            143: {
                id: 143,
                pos: 60,
                group: 8,
                colors: [
                    '#fad8e9',
                    '#e6b0d8',
                    '#be7cae',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            144: {
                id: 144,
                pos: 61,
                group: 8,
                colors: [
                    '#faa1fc',
                    '#f3bffd',
                    '#824fa7',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            145: {
                id: 145,
                pos: 62,
                group: 8,
                colors: [
                    '#d6b2db',
                    '#f5d1f5',
                    '#824fa7',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            146: {
                id: 146,
                pos: 63,
                group: 8,
                colors: [
                    '#dfb2c7',
                    '#f4cacb',
                    '#7d5f9f',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            147: {
                id: 147,
                pos: 64,
                group: 8,
                colors: [
                    '#cbb5e6',
                    '#e1c9fd',
                    '#7a4889',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            160: {
                id: 160,
                pos: 65,
                group: 9,
                colors: [
                    '#85339d',
                    '#a96eb9',
                    '#ebc7dd',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            161: {
                id: 161,
                pos: 66,
                group: 9,
                colors: [
                    '#68328c',
                    '#7755a5',
                    '#cf98e0',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            162: {
                id: 162,
                pos: 67,
                group: 9,
                colors: [
                    '#8c3a87',
                    '#d3a7d9',
                    '#ffeee2',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            163: {
                id: 163,
                pos: 68,
                group: 9,
                colors: [
                    '#69328b',
                    '#a34ed8',
                    '#f3bb2c',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            164: {
                id: 164,
                pos: 69,
                group: 9,
                colors: [
                    '#a34ed8',
                    '#b565d5',
                    '#fcc3b3',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            165: {
                id: 165,
                pos: 70,
                group: 9,
                colors: [
                    '#7025d9',
                    '#8d69f0',
                    '#f3bb2c',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            166: {
                id: 166,
                pos: 71,
                group: 9,
                colors: [
                    '#4b1d70',
                    '#7654a5',
                    '#fba497',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            167: {
                id: 167,
                pos: 72,
                group: 9,
                colors: [
                    '#8e6bbf',
                    '#d2bbf2',
                    '#452077',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            180: {
                id: 180,
                pos: 73,
                group: 10,
                colors: [
                    '#d9c6b0',
                    '#f2e5d5',
                    '#7c6b86',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            181: {
                id: 181,
                pos: 74,
                group: 10,
                colors: [
                    '#d9b991',
                    '#f2e0bd',
                    '#9b7e6c',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            182: {
                id: 182,
                pos: 75,
                group: 10,
                colors: [
                    '#f2d6b3',
                    '#d9c5a0',
                    '#d36422',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            183: {
                id: 183,
                pos: 76,
                group: 10,
                colors: [
                    '#d9cdbf',
                    '#f2eadf',
                    '#a57e68',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            184: {
                id: 184,
                pos: 77,
                group: 10,
                colors: [
                    '#d9d4ba',
                    '#a69580',
                    '#50506c',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            185: {
                id: 185,
                pos: 78,
                group: 10,
                colors: [
                    '#d9c49c',
                    '#f2ebdc',
                    '#4f576a',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            186: {
                id: 186,
                pos: 79,
                group: 10,
                colors: [
                    '#d9bd8b',
                    '#d9d4ba',
                    '#726779',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            187: {
                id: 187,
                pos: 80,
                group: 10,
                colors: [
                    '#f2e0bd',
                    '#d9b991',
                    '#5e6771',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            200: {
                id: 200,
                pos: 81,
                group: 11,
                colors: [
                    '#714624',
                    '#946637',
                    '#debb8c',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            201: {
                id: 201,
                pos: 82,
                group: 11,
                colors: [
                    '#946637',
                    '#b27e4d',
                    '#ffecc9',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            202: {
                id: 202,
                pos: 83,
                group: 11,
                colors: [
                    '#895f17',
                    '#bca277',
                    '#fcf1d5',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            203: {
                id: 203,
                pos: 84,
                group: 11,
                colors: [
                    '#8c6450',
                    '#a67e5b',
                    '#9dd1c5',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            204: {
                id: 204,
                pos: 85,
                group: 11,
                colors: [
                    '#64392b',
                    '#9a6551',
                    '#d0bd98',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            205: {
                id: 205,
                pos: 86,
                group: 11,
                colors: [
                    '#593d2d',
                    '#a68c76',
                    '#a6d6cd',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            206: {
                id: 206,
                pos: 87,
                group: 11,
                colors: [
                    '#532120',
                    '#a27865',
                    '#e0bca9',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            207: {
                id: 207,
                pos: 88,
                group: 11,
                colors: [
                    '#825538',
                    '#ba7a55',
                    '#edd9b2',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            220: {
                id: 220,
                pos: 89,
                group: 12,
                colors: [
                    '#6e6e6e',
                    '#1f1f1f',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            900: {
                id: 900,
                pos: 90,
                group: 13,
                colors: [
                    '#011e40',
                    '#a1a9b3',
                    '#fffce6',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#011933',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            901: {
                id: 901,
                pos: 91,
                group: 13,
                colors: [
                    '#a6918a',
                    '#b39d96',
                    '#401704',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#331403',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            902: {
                id: 902,
                pos: 92,
                group: 13,
                colors: [
                    '#a68a8e',
                    '#b3969b',
                    '#400006',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#330006',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            903: {
                id: 903,
                pos: 93,
                group: 13,
                colors: [
                    '#8b9aa6',
                    '#97a7b3',
                    '#011e40',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#011933',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            904: {
                id: 904,
                pos: 94,
                group: 13,
                colors: [
                    '#8aa6a5',
                    '#96b3b0',
                    '#083b41',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            905: {
                id: 905,
                pos: 95,
                group: 13,
                colors: [
                    '#330002',
                    '#400003',
                    '#ececec',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            906: {
                id: 906,
                pos: 96,
                group: 13,
                colors: [
                    '#47271b',
                    '#99543d',
                    '#ececec',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            907: {
                id: 907,
                pos: 97,
                group: 13,
                colors: [
                    '#2e1911',
                    '#47271b',
                    '#cccccc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            908: {
                id: 908,
                pos: 98,
                group: 13,
                colors: [
                    '#2d1512',
                    '#47211c',
                    '#cccccc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            909: {
                id: 909,
                pos: 99,
                group: 13,
                colors: [
                    '#011933',
                    '#011e40',
                    '#ececec',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            910: {
                id: 910,
                pos: 100,
                group: 13,
                colors: [
                    '#010d1a',
                    '#011933',
                    '#cccccc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            911: {
                id: 911,
                pos: 101,
                group: 13,
                colors: [
                    '#1b3047',
                    '#3d6899',
                    '#ececec',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            912: {
                id: 912,
                pos: 102,
                group: 13,
                colors: [
                    '#121f2d',
                    '#1b3047',
                    '#cccccc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            913: {
                id: 913,
                pos: 103,
                group: 13,
                colors: [
                    '#1d3846',
                    '#3d7899',
                    '#ececec',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            914: {
                id: 914,
                pos: 104,
                group: 13,
                colors: [
                    '#12242c',
                    '#1d3846',
                    '#cccccc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            915: {
                id: 915,
                pos: 105,
                group: 13,
                colors: [
                    '#021a0f',
                    '#07331d',
                    '#cccccc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            916: {
                id: 916,
                pos: 106,
                group: 13,
                colors: [
                    '#122d1f',
                    '#1d4730',
                    '#cccccc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            917: {
                id: 917,
                pos: 107,
                group: 13,
                colors: [
                    '#bfa826',
                    '#ccb729',
                    '#151515',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#0f0f0f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            918: {
                id: 918,
                pos: 108,
                group: 13,
                colors: [
                    '#bf2815',
                    '#cc3317',
                    '#151515',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#0f0f0f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            919: {
                id: 919,
                pos: 109,
                group: 13,
                colors: [
                    '#bf1114',
                    '#ef1519',
                    '#090909',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#000000',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            920: {
                id: 920,
                pos: 110,
                group: 13,
                colors: [
                    '#bf1114',
                    '#ef1519',
                    '#090909',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#0f0f0f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            921: {
                id: 921,
                pos: 111,
                group: 13,
                colors: [
                    '#34be60',
                    '#39cc5f',
                    '#151515',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#0f0f0f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            922: {
                id: 922,
                pos: 112,
                group: 13,
                colors: [
                    '#35be25',
                    '#3acc27',
                    '#151515',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#0f0f0f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            923: {
                id: 923,
                pos: 113,
                group: 13,
                colors: [
                    '#e6ad29',
                    '#fdb62c',
                    '#0d471b',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#062d12',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            924: {
                id: 924,
                pos: 114,
                group: 13,
                colors: [
                    '#e6ad29',
                    '#fdb62c',
                    '#1c4247',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#122a2e',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            925: {
                id: 925,
                pos: 115,
                group: 13,
                colors: [
                    '#e6ad29',
                    '#fdb62c',
                    '#1c3547',
                    '#070606',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#12222d',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            926: {
                id: 926,
                pos: 116,
                group: 13,
                colors: [
                    '#141414',
                    '#595959',
                    '#cccccc',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#070606',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ]
            },
            927: {
                id: 927,
                pos: 117,
                group: 13,
                colors: [
                    'var(--test-color-1)',
                    'var(--test-color-2)',
                    'var(--test-color-3)',
                    'var(--test-color-4)',
                    'var(--test-color-5)',
                    'var(--test-color-6)',
                    'var(--test-color-7)',
                    'var(--test-color-8)',
                    'var(--test-color-9)',
                    'var(--test-color-10)',
                    'var(--test-color-11)',
                    'var(--test-color-12)',
                    'var(--test-color-13)'
                ]
            }
        },
        colorgroups: {
            1: { id: 1, pos: 1 },
            2: { id: 2, pos: 2 },
            3: { id: 3, pos: 3 },
            4: { id: 4, pos: 4 },
            5: { id: 5, pos: 5 },
            6: { id: 6, pos: 6 },
            7: { id: 7, pos: 7 },
            8: { id: 8, pos: 8 },
            9: { id: 9, pos: 9 },
            10: { id: 10, pos: 10 },
            11: { id: 11, pos: 11 },
            12: { id: 12, pos: 12 },
            13: { id: 13, pos: 13, type: 'legacy' },
            14: { id: 14, pos: 14, type: 'logo' },
            15: { id: 15, pos: 15, type: 'custom' }
        }
    },
    mutations: {},
    getters: {
        getColorgroups(state, getters) {
            let data = [],
                logo = getters.getProp('deha.user.misc.logo.id');
            toArray(state.colorgroups).forEach((colorgroups__value) => {
                /* hide legacy group */
                if (
                    (getters.getActiveColorschemeLegacy === undefined ||
                        getters.getActiveColorschemeLegacy === null ||
                        getters.getActiveColorschemeLegacy === '') &&
                    colorgroups__value.type === 'legacy'
                ) {
                    return;
                }
                /* hide logo group */
                if (
                    (logo === undefined || logo === null || logo === '') &&
                    colorgroups__value.type === 'logo'
                ) {
                    return;
                }
                data.push(colorgroups__value);
            });
            return data;
        },
        getActiveColorgroupId(state, getters) {
            let id = null;
            if (getters.getActiveColorscheme) {
                if (
                    getters.getActiveColorscheme === 'logo' ||
                    getters.getActiveColorscheme === 'custom'
                ) {
                    toArray(state.colorgroups).forEach((colorgroups__value) => {
                        if (colorgroups__value.type === getters.getActiveColorscheme) {
                            id = colorgroups__value.id;
                        }
                    });
                } else {
                    id = state.colorschemes[getters.getActiveColorscheme].group;
                }
            }
            return id;
        },
        colorschemesInActiveColorgroup(state, getters) {
            let colorgroup = getters.getColorgroup(getters.getActiveColorgroupId);
            if (colorgroup.type === 'logo') {
                return getters.getLogoColors;
            } else {
                return getters.getColorschemes.filter((i) => i.group == colorgroup.id);
            }
        },
        getColorschemes(state, getters) {
            let colorSchemes = [];
            toArray(state.colorschemes).forEach((colorschemes__value) => {
                /* hide debug colorscheme */
                if (getEnvironment() === 'production' && colorschemes__value.id === 927) {
                    return;
                }
                /* hide legacy colorschemes */
                if (
                    getters.getActiveColorschemeLegacy !== undefined &&
                    getters.getActiveColorschemeLegacy !== null &&
                    getters.getActiveColorschemeLegacy !== colorschemes__value.id &&
                    colorschemes__value.id >= 900
                ) {
                    return;
                }
                colorSchemes.push(colorschemes__value);
            });
            return colorSchemes;
        },
        getColorgroup(state) {
            return (id) => {
                let ret = null;
                toArray(state.colorgroups).forEach((colorgroups__value) => {
                    if (colorgroups__value.id == id) {
                        ret = colorgroups__value;
                        return false;
                    }
                });
                return ret;
            };
        },
        getColorscheme(state) {
            return (id) => {
                let ret = null;
                toArray(state.colorschemes).forEach((colorschemes__value) => {
                    if (colorschemes__value.id == id) {
                        ret = colorschemes__value;
                        return false;
                    }
                });
                return ret;
            };
        },
        getColorschemeColor(state, getters) {
            return (val, number) => {
                let ret = null;
                if (val.toString().indexOf('logo') > -1) {
                    toArray(getters.getLogoColors).forEach((colors__value, colors__key) => {
                        if (
                            (val === 'logo' && colors__value.active === true) ||
                            val.replace('logo.', '') == colors__key + 1
                        ) {
                            ret = colors__value.colors[number - 1];
                            return false;
                        }
                    });
                } else if (val === 'custom') {
                    ret = toArray(getters.getCustomColors)[number - 1];
                } else {
                    toArray(state.colorschemes).forEach((colorschemes__value) => {
                        if (colorschemes__value.id === val) {
                            ret = colorschemes__value.colors[number - 1];
                            return false;
                        }
                    });
                }
                return ret;
            };
        },
        getActiveColorscheme(state, getters) {
            return getters.getProp('tecpage.user.settings.colorscheme');
        },
        getActiveColorschemeLegacy(state, getters) {
            return getters.getProp('tecpage.user.settings.colorscheme_legacy');
        },
        getActiveColors(state, getters) {
            let ret = [],
                val = getters.getActiveColorscheme;
            if (val === 'logo') {
                let colors_logo = getters.getLogoColors;
                if (colors_logo !== null && colors_logo !== undefined && colors_logo !== '') {
                    toArray(colors_logo).forEach((colors_logo__value) => {
                        if (colors_logo__value.active === true) {
                            toArray(colors_logo__value.colors).forEach(
                                (colors__value, colors__key) => {
                                    ret.push({
                                        key: colors__key + 1,
                                        value: colors__value
                                    });
                                }
                            );
                        }
                    });
                }
            } else if (val === 'custom') {
                let colors_custom = getters.getCustomColors;
                if (colors_custom !== null && colors_custom !== undefined && colors_custom !== '') {
                    toArray(colors_custom).forEach((colors_custom__value, colors_custom__key) => {
                        ret.push({
                            key: colors_custom__key + 1,
                            value: colors_custom__value
                        });
                    });
                }
            } else if (!isNaN(val)) {
                let colorscheme = getters.getColorscheme(val);
                if (colorscheme !== null && colorscheme !== undefined && colorscheme !== '') {
                    colorscheme.colors.forEach((colors__value, colors__key) => {
                        ret.push({
                            key: colors__key + 1,
                            value: colors__value
                        });
                    });
                }
            }
            return ret;
        },
        getLogoColors(state, getters) {
            let prop = getters.getProp('tecpage.user.settings.misc.colors_logo');
            if (prop === undefined || prop === null || prop === '') {
                return [];
            }
            return prop;
        },
        getLogoColorsActiveId(state, getters) {
            let ret = null;
            toArray(getters.getLogoColors).forEach((colors__value) => {
                if (colors__value.active === true) {
                    ret = colors__value.id;
                    return false;
                }
            });
            return ret;
        },
        getCustomColors(state, getters) {
            let prop = getters.getProp('tecpage.user.settings.misc.colors_custom');
            if (prop === undefined || prop === null || prop === '') {
                return [];
            }
            return prop;
        },
        getCustomColor(state, getters) {
            return (id) => {
                let colors = getters.getCustomColors;
                if (toArray(colors).length >= id) {
                    return toArray(colors)[id - 1];
                }
                return null;
            };
        },
        getContrastColor() {
            return (hexcolor) => {
                hexcolor = hexcolor.replace('#', '');
                let r = parseInt(hexcolor.substr(0, 2), 16),
                    g = parseInt(hexcolor.substr(2, 2), 16),
                    b = parseInt(hexcolor.substr(4, 2), 16),
                    yiq = (r * 299 + g * 587 + b * 114) / 1000;
                return yiq >= 128 ? '#000000' : '#ffffff';
            };
        },
        enhanceOtherColors(state, getters) {
            return (colors) => {
                let shift = 12;
                if (
                    getters.deltaEImproved(colors[0], '#ffffff') + shift >
                    getters.deltaEImproved(colors[0], '#000000')
                ) {
                    colors[3] = '#ffffff';
                    colors[6] = '#ffffff';
                } else {
                    colors[3] = '#070606';
                    colors[6] = '#070606';
                }
                if (
                    getters.deltaEImproved(colors[1], '#ffffff') + shift >
                    getters.deltaEImproved(colors[1], '#000000')
                ) {
                    colors[4] = '#ffffff';
                    colors[7] = '#ffffff';
                } else {
                    colors[4] = '#070606';
                    colors[7] = '#070606';
                }
                if (
                    getters.deltaEImproved(colors[2], '#ffffff') + shift >
                    getters.deltaEImproved(colors[2], '#000000')
                ) {
                    colors[5] = '#ffffff';
                    colors[8] = '#ffffff';
                } else {
                    colors[5] = '#070606';
                    colors[8] = '#070606';
                }
                colors[9] = '#1F1F1F';
                colors[10] = '#3E3E3E';
                colors[11] = '#E6E6E6';
                colors[12] = '#ffffff';
                return colors;
            };
        },

        rgbToHex() {
            return (r, g, b) => {
                return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
            };
        },

        hexToRgb() {
            return (hex) => {
                let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result
                    ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
                    : null;
            };
        },

        deltaEImproved(state, getters) {
            return (hexA, hexB) => {
                let color1 = {
                    L: getters.rgbToLab(getters.hexToRgb(hexA))[0],
                    A: getters.rgbToLab(getters.hexToRgb(hexA))[1],
                    B: getters.rgbToLab(getters.hexToRgb(hexA))[2]
                };
                let color2 = {
                    L: getters.rgbToLab(getters.hexToRgb(hexB))[0],
                    A: getters.rgbToLab(getters.hexToRgb(hexB))[1],
                    B: getters.rgbToLab(getters.hexToRgb(hexB))[2]
                };
                return DeltaE.getDeltaE00(color1, color2);
            };
        },

        isValidHex() {
            return (hex) => {
                return /^#[0-9A-F]{6}$/i.test(hex);
            };
        },

        rgbToLab() {
            return (rgb) => {
                let r = rgb[0] / 255,
                    g = rgb[1] / 255,
                    b = rgb[2] / 255,
                    x,
                    y,
                    z;
                r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
                g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
                b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
                x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
                y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
                z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
                x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
                y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
                z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
                return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
            };
        },

        strRgbToHex(state, getters) {
            return (str) => {
                str = str.replace('rgb(', '');
                str = str.replace('rgba(', '');
                str = str.split(',');
                return getters.rgbToHex(parseInt(str[0]), parseInt(str[1]), parseInt(str[2]));
            };
        },

        changeBrightness(state, getters) {
            return (color) => {
                let signum = 1;
                return getters.shadeColor(color, signum * 20);
            };
        },

        shadeColor() {
            return (color, percent) => {
                var R = parseInt(color.substring(1, 3), 16);
                var G = parseInt(color.substring(3, 5), 16);
                var B = parseInt(color.substring(5, 7), 16);

                R = parseInt((R * (100 + percent)) / 100);
                G = parseInt((G * (100 + percent)) / 100);
                B = parseInt((B * (100 + percent)) / 100);

                R = R < 255 ? R : 255;
                G = G < 255 ? G : 255;
                B = B < 255 ? B : 255;

                var RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16);
                var GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16);
                var BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16);

                return '#' + RR + GG + BB;
            };
        }
    },
    actions: {
        async saveColorsFromCurrentLogo(context) {
            let logo_id = context.getters.getProp('deha.user.misc.logo.id');
            if (logo_id) {
                let url = context.rootGetters.generateMediaUrl({
                    id: logo_id,
                    h: 400
                });
                url = url.replace('vielhuber.de', 'vielhuber.de:8080');

                let colors = [];

                const colorThief = new ColorThief();
                const img = new Image();

                img.addEventListener('load', () => {
                    let results = colorThief.getPalette(img, 10, 1);
                    analyze(url).then((rawColors) => {
                        /* simple algorithm */

                        // fill out bg with white pixels
                        let pixelCount = img.naturalWidth * img.naturalHeight;
                        let pixelCountDetected = 0;
                        for (let i = 0; i < rawColors.length; i++) {
                            if (rawColors[i] === undefined) {
                                continue;
                            }
                            pixelCountDetected += rawColors[i].count;
                        }
                        if (pixelCount > pixelCountDetected) {
                            rawColors.push({
                                color: 'rgb(255,255,255)',
                                count: pixelCount - pixelCountDetected
                            });
                        }

                        // #1: sort out rgba
                        for (let i = 0; i < rawColors.length; i++) {
                            if (rawColors[i] === undefined) {
                                continue;
                            }
                            if (rawColors[i].color.indexOf('rgba') > -1) {
                                delete rawColors[i];
                            }
                        }
                        rawColors = rawColors.filter((v) => typeof v !== 'undefined'); // sort out empty

                        // #2: squash together similiar colors
                        let rawColorsCount = 0;
                        for (let i = 0; i < rawColors.length; i++) {
                            if (rawColors[i] === undefined) {
                                continue;
                            }
                            rawColorsCount += rawColors[i].count;
                        }
                        for (let i = 0; i < rawColors.length; i++) {
                            if (rawColors[i] === undefined) {
                                continue;
                            }
                            for (let j = 0; j < rawColors.length; j++) {
                                if (rawColors[j] === undefined) {
                                    continue;
                                }
                                if (j <= i) {
                                    continue;
                                }
                                if (
                                    (rawColors[j].count / rawColorsCount >= 0.2 &&
                                        context.getters.deltaEImproved(
                                            context.getters.strRgbToHex(rawColors[i].color),
                                            context.getters.strRgbToHex(rawColors[j].color)
                                        ) < 6) ||
                                    (rawColors[j].count / rawColorsCount < 0.2 &&
                                        context.getters.deltaEImproved(
                                            context.getters.strRgbToHex(rawColors[i].color),
                                            context.getters.strRgbToHex(rawColors[j].color)
                                        ) < 11)
                                ) {
                                    rawColors[i].count += rawColors[j].count;
                                    delete rawColors[j];
                                }
                            }
                        }
                        rawColors = rawColors.filter((v) => typeof v !== 'undefined'); // sort out empty
                        rawColors = rawColors.sort((a, b) => Math.sign(b.count - a.count));

                        // #3: remove very small portions
                        rawColorsCount = 0;
                        for (let i = 0; i < rawColors.length; i++) {
                            if (rawColors[i] === undefined) {
                                continue;
                            }
                            rawColorsCount += rawColors[i].count;
                        }
                        for (let i = 0; i < rawColors.length; i++) {
                            if (rawColors[i] === undefined) {
                                continue;
                            }
                            if (rawColors[i].count / rawColorsCount < 0.01) {
                                delete rawColors[i];
                            }
                        }
                        rawColors = rawColors.filter((v) => typeof v !== 'undefined'); // sort out empty

                        // #4: remove black/white and add sw
                        let addBlackWhite = false;
                        for (let i = 0; i < rawColors.length; i++) {
                            if (rawColors[i] === undefined) {
                                continue;
                            }
                            let color = context.getters.strRgbToHex(rawColors[i].color);
                            if (
                                context.getters.deltaEImproved(color, '#ffffff') <= 10 ||
                                context.getters.deltaEImproved(color, '#000000') <= 10
                            ) {
                                addBlackWhite = true;
                                delete rawColors[i];
                            }
                        }
                        rawColors = rawColors.filter((v) => typeof v !== 'undefined'); // sort out empty

                        // #5
                        let helperCount = 0;
                        for (let i = 0; i < rawColors.length; i++) {
                            if (rawColors[i] === undefined) {
                                continue;
                            }
                            helperCount++;
                        }
                        if (helperCount <= 5) {
                            let addMax = addBlackWhite === true ? 2 : 3;
                            for (let i = 0; i < addMax; i++) {
                                if (rawColors[i] === undefined) {
                                    continue;
                                }
                                let color = context.getters.strRgbToHex(rawColors[i].color);
                                colors.push(color);
                            }
                            if (addBlackWhite === true) {
                                colors.push('sw');
                            }
                            if (colors.length > 0) {
                                //colors.push('#e400ff');
                            }
                        } else {
                            /* advanced algorithm */
                            // convert
                            for (let i = 0; i < results.length; i++) {
                                results[i] = context.getters.rgbToHex(
                                    results[i][0],
                                    results[i][1],
                                    results[i][2]
                                );
                            }
                            // immediately sort out light/dark colors
                            let includedBlackOrWhite = false;
                            for (let i = 0; i < results.length; i++) {
                                if (
                                    context.getters.deltaEImproved(results[i], '#ffffff') < 22.5 ||
                                    context.getters.deltaEImproved(results[i], '#000000') < 22.5
                                ) {
                                    includedBlackOrWhite = true;
                                    delete results[i];
                                }
                            }
                            results = results.filter((v) => v != null); // sort out empty
                            if (results.length > 0) {
                                // take most dominant color
                                colors.push(results[0]);
                                delete results[0];
                                results = results.filter((v) => v != null); // sort out empty
                                // round 1: take two most dominant other colors
                                for (let i = 0; i < results.length; i++) {
                                    if (i >= 3) {
                                        break;
                                    }
                                    let alreadyExists = false;
                                    for (let colors__value of colors) {
                                        if (
                                            context.getters.deltaEImproved(
                                                colors__value,
                                                results[i]
                                            ) < 40
                                        ) {
                                            alreadyExists = true;
                                        }
                                    }
                                    if (alreadyExists === false) {
                                        colors.push(results[i]);
                                        if (colors.length >= 3) {
                                            break;
                                        }
                                    }
                                }
                                // round 2: if no color was found in previous round, take not so dominant other colors
                                if (
                                    colors.length <= 1 ||
                                    (colors.length === 2 && includedBlackOrWhite === false)
                                ) {
                                    for (let i = 0; i < results.length; i++) {
                                        if (i >= 3) {
                                            break;
                                        }
                                        let alreadyExists = false;
                                        for (let colors__value of colors) {
                                            if (
                                                context.getters.deltaEImproved(
                                                    colors__value,
                                                    results[i]
                                                ) < 20
                                            ) {
                                                alreadyExists = true;
                                            }
                                        }
                                        if (alreadyExists === false) {
                                            colors.push(results[i]);
                                            if (colors.length >= 2) {
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                            // add black or white
                            if (colors.length < 3 && includedBlackOrWhite === true) {
                                colors.push('sw');
                            }
                        }

                        // always add up to 3 colors
                        if (colors.length === 0) {
                            colors.push('sw');
                        }
                        if (colors.length === 1 && colors[0] === 'sw') {
                            colors.splice(0, 0, '#444444');
                            colors.splice(1, 0, context.getters.changeBrightness(colors[0]));
                        }
                        if (colors.length < 3) {
                            while (colors.length < 3) {
                                colors.splice(
                                    1,
                                    0,
                                    context.getters.changeBrightness(
                                        colors[1] === 'sw' ? colors[0] : colors[1]
                                    )
                                );
                            }
                            //colors.push('#ff4edc');
                        }

                        // we now generate the final versions
                        let variations = [];
                        if (colors.includes('sw')) {
                            variations.push({
                                id: 1,
                                active: true,
                                colors: [colors[0], colors[1], '#000000']
                            });
                            variations.push({
                                id: 2,
                                active: false,
                                colors: [colors[1], colors[0], '#000000']
                            });
                            variations.push({
                                id: 3,
                                active: false,
                                colors: [colors[0], colors[1], '#ffffff']
                            });
                            variations.push({
                                id: 4,
                                active: false,
                                colors: [colors[1], colors[0], '#ffffff']
                            });
                        } else {
                            variations.push({
                                id: 1,
                                active: true,
                                colors: [colors[0], colors[1], colors[2]]
                            });
                            variations.push({
                                id: 2,
                                active: false,
                                colors: [colors[1], colors[0], colors[2]]
                            });
                        }
                        variations.forEach((variations__value) => {
                            variations__value.colors = context.getters.enhanceOtherColors(
                                variations__value.colors
                            );
                        });
                        context.dispatch('setProp', {
                            source: 'tecpage.user.settings.misc.colors_logo',
                            value: variations
                        });
                        context.dispatch('updateColorschemeVars');
                        context.dispatch('saveAllData');
                    });
                });
                img.crossorigin = 'anonymous';
                img.src = url;
            } else {
                context.dispatch('removeProp', {
                    source: 'tecpage.user.settings.misc.colors_logo'
                });
                context.dispatch('updateColorschemeVars');
                context.dispatch('saveAllData');
            }
        },
        async updateColorschemeVars(context) {
            context.getters.getActiveColors.forEach((colors__value) => {
                context.dispatch('updateColorschemeVarsSetColor', {
                    key: colors__value.key,
                    value: colors__value.value
                });
            });
        },

        async updateColorschemeVarsSetColor(context, payload) {
            document.documentElement.style.setProperty(
                '--custom-color-' + payload.key,
                payload.value
            );
            let rgb = context.getters.hexToRgb(payload.value);
            document.documentElement.style.setProperty(
                '--custom-color-rgb-' + payload.key,
                rgb[0] + ', ' + rgb[1] + ', ' + rgb[2]
            );
        },

        async setLogoColorActive(context, id) {
            let colors_logo = context.getters.getProp('tecpage.user.settings.misc.colors_logo');
            if (colors_logo !== undefined && colors_logo !== null && colors_logo !== '') {
                colors_logo = toArray(colors_logo);
                colors_logo.forEach((colors_logo__value) => {
                    colors_logo__value.active = colors_logo__value.id == id;
                });
            }
            context.dispatch('setProp', {
                source: 'tecpage.user.settings.misc.colors_logo',
                value: colors_logo
            });
            context.dispatch('updateColorschemeVars');
        },

        async setCustomColor(context, payload) {
            let colors_custom = context.getters.getCustomColors;
            if (colors_custom.length === 0) {
                context.dispatch('setCustomColorsDefault');
                colors_custom = context.getters.getCustomColors;
            }
            colors_custom = toArray(colors_custom);
            if (context.getters.isValidHex(payload.value) === false) {
                payload.value = '#ffffff';
            }
            colors_custom[payload.id - 1] = payload.value;
            colors_custom = context.getters.enhanceOtherColors(colors_custom);
            context.dispatch('setProp', {
                source: 'tecpage.user.settings.misc.colors_custom',
                value: colors_custom
            });
            context.dispatch('updateColorschemeVars');
        },

        async setCustomColorsDefault(context) {
            let colors_custom;
            if (toArray(context.getters.getActiveColors).length > 0) {
                colors_custom = toArray(context.getters.getActiveColors).map((el) => el.value);
            } else {
                colors_custom = [
                    '#6e6e6e',
                    '#1f1f1f',
                    '#ffffff',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#ffffff',
                    '#ffffff',
                    '#070606',
                    '#1f1f1f',
                    '#3e3e3e',
                    '#e6e6e6',
                    '#ffffff'
                ];
            }
            context.dispatch('setProp', {
                source: 'tecpage.user.settings.misc.colors_custom',
                value: colors_custom
            });
            context.dispatch('updateColorschemeVars');
        }
    }
};
